const InCodeDiagram = ({ t }) => (
  <div className="immob-incode">
    <span className="immob-incode-title">{t('common:pats-incode-title')}</span>
    <div className="immob-incode-code">
      <span className="seq-1">54BBCAF912B14A11</span><span className="seq-2">B1A753A373024EC7</span>
    </div>
    <div className="immob-incode-seqlabels">
      <span>{t('common:pats-incode-1')}</span>
      <span>{t('common:pats-incode-2')}</span>
    </div>
    <div className="immob-incode-flow">
      <div className="immob-incode-arrow">
        <span>MGSS</span>
        <span className="arrow">{'↓'}</span>
        <span>MDARS</span>
      </div>
      <div className="immob-incode-boxes">
        <div>
          <span>{t('common:pats-incode-bcm-1')}</span>
          <div className="box" />
        </div>
        <div>
          <span>{t('common:pats-incode-bcm-2')}</span>
          <div className="box" />
        </div>
      </div>
    </div>
  </div>
)

export default InCodeDiagram



// WEBPACK FOOTER //
// ./components/PATSCodes/InCodeDiagram.js